import { render, staticRenderFns } from "./addStaff.page.vue?vue&type=template&id=bd7775c2&scoped=true&"
import script from "./addStaff.page.vue?vue&type=script&lang=js&"
export * from "./addStaff.page.vue?vue&type=script&lang=js&"
import style0 from "./addStaff.page.vue?vue&type=style&index=0&id=bd7775c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd7775c2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\mzkj\\要炼\\yl-pc-business\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd7775c2')) {
      api.createRecord('bd7775c2', component.options)
    } else {
      api.reload('bd7775c2', component.options)
    }
    module.hot.accept("./addStaff.page.vue?vue&type=template&id=bd7775c2&scoped=true&", function () {
      api.rerender('bd7775c2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/rolePage/staff/addStaff.page.vue"
export default component.exports